export const LoginConstants = {
  INVALID_CRADENTIALS:"Please enter email address or password.",
  LOGIN_SUCCESSFUL:"Login successfully."
}

export const TokenConstants = {
  Session_Expired : "Your session has been expired, Please login again!"
}

export const ErrorMessageConstants = {
  Message:"Something went wrong ! Please try again after sometime."
}

export const RecoverPassword = {
  Confirm_Password:"New password and confirm password are different."
}

export const VerificationOTP = {
  NO_OTP:'Please enter verification code.',
  INVALID_OTP:'Please enter valid verification code.'
}

export const College = {
  ACTIVE:'College activated successfully.',
  INACTIVE:'College inactivated successfully.',
}

export const CollegeBatch = {
  ACTIVE:'College batch activated successfully.',
  INACTIVE:'College batch inactivated successfully.',
}

export const ParentTechnologyPreference = {
  ACTIVE:'Parent technology activated successfully.',
  INACTIVE:'Parent technology inactivated successfully.',
}

export const ChildTechnologyPreference = {
  ACTIVE:'Parent technology activated successfully.',
  INACTIVE:'Parent technology inactivated successfully.',
}

export const QuestionSet = {
  ACTIVE: 'Question set activated successfully.',
  INACTIVE: 'Question set inactivated successfully.',
}

export const QuestionStatus = {
  ACTIVE:'Question activated successfully.',
  INACTIVE:'Question inactivated successfully.',
}

export const QuestionImage = {
  IMAGE_INVALID:"Question image doesn't have a valid format."
}

export const DirtyCheck = {
  TITLE:'Unsaved changes.',
  MESSAGE:'Are you sure you want to leave this page? You have unsaved changes.',
}

export const User = {
  ACTIVE:'User activated successfully.',
  INACTIVE:'User inactivated successfully.',
}

export const CompanyUser = {
  ACTIVE:'Company User activated successfully.',
  INACTIVE:'Company User inactivated successfully.',
}

export const StudentConstant = {
  ACTIVE:'Student activated successfully.',
  INACTIVE:'Student inactivated successfully.',
}

export const DeleteConstant = {
  DELETE:'Do you want to delete this',
  ARE_YOU_SURE:'Are you sure ?',
}

export const Company = {
  ACTIVE:'Company activated successfully.',
  INACTIVE:'Company inactivated successfully.',
}
export const Job = {
  ACTIVE:'Job activated successfully.',
  INACTIVE:'Job inactivated successfully.',
}

export const StatusConstant = {
  CHANGE_STATUS:'Change status',
  ARE_YOU_SURE:'Are you sure you want to',
}

export const TestLiveConstant = {
  CONFIRM_LIVE:'Do you want to let the exam go live',
  CONFIRM_HOLD:'Do you want to let the exam go hold',
  ARE_YOU_SURE:'Are you sure ?',
}

export const TestSaveConstant = {
  CONFIRM: 'Do you want to save the exam',
  EditTestConfirm: 'Are you sure you want to update exam',
  ARE_YOU_SURE:'Are you sure ?'
}